// extracted by mini-css-extract-plugin
export default {"list":"CommonMenu_list__EseOb"};